import { ShortUrlObjectType } from '@air/api/types';

import { SharePublicItemModal, type SharePublicItemModalProps } from '../SharePublicItemModal';

export type SharePublicBoardModalProps = {} & AirModalProps & Omit<SharePublicItemModalProps, 'type'>;

export const SharePublicBoardModal = (props: SharePublicBoardModalProps) => {
  return <SharePublicItemModal {...props} type={ShortUrlObjectType.board} />;
};
